import { createContext, useContext } from 'react';

import type { WebformQuizQuestion, WebformRadiosWithImageImage } from '../components/Webform/types';

export type QuestionPage = 'question' | 'answer';

export interface QuizPage {
  id: string;
  title: string;
}

export interface QuizQuestion {
  id: string;
  type: WebformQuizQuestion['#type'];
  parentId: string;
  title: string;
  description: string;
  options: Record<string, string>;
  images?: Record<string, WebformRadiosWithImageImage>;
  currentPage: QuestionPage;
  showAnswerOnNewPage?: boolean;
  correctAnswers: string[];
  givenAnswers: string[];
  readMore: string;
  isCorrect?: boolean;
}

export interface QuizScore {
  total: number;
  correct: number;
}

export interface QuizContextProps {
  quizId: string;
  quizPages: QuizPage[];
  quizQuestions: QuizQuestion[];
  currentQuizQuestion?: QuizQuestion;
  quizScore: QuizScore;
  updateQuizQuestion: (value: Pick<QuizQuestion, 'id'> & Partial<Omit<QuizQuestion, 'id'>>) => void;
  updateCurrentQuizQuestionId: React.Dispatch<React.SetStateAction<QuizQuestion['id']>>;
  resetQuiz: () => void;
}

export const QuizContext = createContext<QuizContextProps>({
  quizId: '',
  quizPages: [],
  quizQuestions: [],
  quizScore: { total: 0, correct: 0 },
  updateQuizQuestion: () => {},
  updateCurrentQuizQuestionId: () => {},
  resetQuiz: () => {},
});

export function useQuizContext() {
  return useContext(QuizContext);
}
